import { Component, EventEmitter, Input, Output } from '@angular/core';


/**
 * Reusable retry button component with icon
 * Used across the application for retry operations
 */
@Component({
    selector: 'sabis-retry-button',
    templateUrl: './retry-button.component.html',
    styleUrl: './retry-button.component.scss',
    imports: []
})
export class RetryButtonComponent {
  /** Whether the button is disabled */
  @Input() disabled: boolean = false;

  /** Button title (tooltip) */
  @Input() title: string = 'Retry';

  /** Button type (button or submit) */
  @Input() type: 'button' | 'submit' = 'button';

  /** Emits when the button is clicked */
  @Output() retryClick = new EventEmitter<void>();

  /**
   * Handle button click
   */
  public onClick(): void {
    if (!this.disabled) {
      this.retryClick.emit();
    }
  }
}
